<template>
  <div class="law-page-container">
    <img class="bg-img" :src="bgImg" alt="" />
    <div class="content">
      <img class="pin-img" :src="pinImg" alt="" />
      <img class="stamp-img" :src="stampImg" alt="" />
      <img class="c-bg-img" :src="cbgImg" alt="" />
      <div class="title">{{ translateTitle("4E执法调查") }}</div>
      <div class="sub-title section-margin-bottom">
        {{ translateTitle("执法调查授权申明") }}
      </div>
      <div class="sub-title">
        {{
          translateTitle(
            "如您想发起执法请求,请将以下信息发送至4E 官网司法协助邮箱: "
          ) + `legal@eeee.com`
        }}
      </div>
      <div class="sub-title section-margin-bottom">
        {{ translateTitle("内容应当包括：") }}
      </div>
      <div class="list-content">
        <div>
          <div
            class="list-content-item"
            v-for="(item, index) in list1"
            :key="index"
          >
            <Icon :name="'icon_1_' + index" />{{ translateTitle(item) }}
          </div>
        </div>
        <div>
          <div
            class="list-content-item"
            v-for="(item, index) in list2"
            :key="index"
          >
            <Icon :name="'icon_2_' + index" />{{ translateTitle(item) }}
          </div>
          <img class="empty-img" :src="emptyImg" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import commonMixin from "@/components/common/commonMixin.vue";
import Icon from "./icon.vue";
import bgImg from "../imgs/bg.png";
import pinDarkImg from "../imgs/pin-dark.png";
import pinLightImg from "../imgs/pin-light.png";
import stampImg from "../imgs/stamp.png";
import cbgDarkImg from "../imgs/c-bg-dark.png";
import cbgLightImg from "../imgs/c-bg-light.png";
import emptyDarkImg from "../imgs/empty-dark.png";
import emptyLightImg from "../imgs/empty-light.png";
export default {
  props: {},
  components: {
    Icon,
  },
  mixins: [commonMixin],
  data() {
    return {
      bgImg,
      stampImg,
      list1: [
        "电子邮箱",
        "机构名称（例如：FBI、SEC）",
        "机构官方电子邮箱地址",
        "机构联系电话",
        "机构网站（如适用）",
        "国家 | 司法管辖区",
        "调查官员（职级、姓名、电子邮箱、联系电话）",
        "请附上您的官方身份证明文件，例如徽章或身份证，以验证您作为执法人员的身份和资质。对于非英文的身份证明文件，请您安排所在国认可的公证人对文件进行公证。",
      ],
      list2: [
        "执法内容更多附件",
        "法律依据（例如：盗窃、欺诈等）",
        "受害人信息（如适用）",
        "背景事实",
        "关键信息（例如：交易哈希 TXID、钱包地址、备注、其他标识符）",
        "提供更多信息",
      ],
    };
  },
  async created() {},
  destroyed() {},
  beforeDestroy() {},
  watch: {
    isDarkMode() {},
  },
  computed: {
    ...mapGetters({
      isDarkMode: "user/isDarkMode",
    }),
    cbgImg() {
      return this.isDarkMode ? cbgDarkImg : cbgLightImg;
    },
    emptyImg() {
      return this.isDarkMode ? emptyDarkImg : emptyLightImg;
    },
    pinImg() {
      return this.isDarkMode ? pinDarkImg : pinLightImg;
    },
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
:root[theme="light"] {
  .law-page-container {
  }
}
:root[theme="dark"] {
  .law-page-container {
    background: linear-gradient(180deg, #262a56 0%, #000 41.91%, #000 105.17%);
  }
  .content {
    background: linear-gradient(
      75deg,
      rgba(43, 46, 58, 0.9) 25.92%,
      #4c4f6e 95.1%
    );
    box-shadow: 0 10px 30px rgba(65, 84, 149, 0.2);

    .title {
      color: #fff;
    }
    .sub-title {
      color: #fff;
    }
    .list-content {
      border: 1px solid #5c5c65;
      background: #47495c;
      color: #fff;
      > div {
        &:first-child {
          &::after {
            background: linear-gradient(
              180deg,
              rgba(255, 255, 255, 0) 0%,
              #989cad 50%,
              rgba(255, 255, 255, 0) 100%
            );
          }
        }
      }
      .list-content-item {
        border-bottom-color: #5a5f71;
      }
    }
  }
}
.law-page-container {
  position: relative;
  min-height: calc(100vh - 444px - 64px);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
    180deg,
    #eff0ff 0%,
    #fefeff 41.91%,
    #fdfdfd 72.43%,
    #fff 105.17%
  );
  .bg-img {
    width: 100vw;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }
  .content {
    margin-top: 130px;
    margin-bottom: 130px;
    min-height: 900px;
    width: 900px;
    border-radius: 8px;
    position: relative;
    z-index: 1;
    padding: 115px 42px 54px 42px;
    background: linear-gradient(
      72deg,
      #fff 27.76%,
      rgba(235, 239, 255, 0.9) 83.23%
    );
    box-shadow: 0 10px 30px rgba(65, 84, 149, 0.2);
    .pin-img {
      width: 98px;
      height: 84px;
      position: absolute;
      top: -18px;
      left: -18px;
    }
    .stamp-img {
      width: 320px;
      height: 183.908px;
      position: absolute;
      top: 20px;
      right: 83px;
    }
    .c-bg-img {
      width: 480px;
      height: 506px;
      aspect-ratio: 240/253;
      position: absolute;
      bottom: 0px;
      right: 0px;
    }
    .title {
      color: #111e8a;
      font-size: 50px;
      font-style: normal;
      font-weight: 600;
      margin-bottom: 80px;
      position: relative;
      z-index: 1;
    }
    .sub-title {
      color: #3e4b6f;
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: 32px; /* 177.778% */
      &.section-margin-bottom {
        margin-bottom: 20px;
      }
    }
    .list-content {
      padding: 22px;
      border-radius: 6px;
      border: 1px solid #b8baef;
      background: #fff;
      color: #3e4b6f;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 38px; /* 237.5% */
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 48px;
      position: relative;
      z-index: 1;
      > div {
        position: relative;
        &:first-child {
          &::after {
            content: "";
            position: absolute;
            top: 0;
            right: -24px;
            width: 2px;
            height: 100%;
            background: linear-gradient(
              180deg,
              #fff 0%,
              #dfe5fe 50%,
              #fff 100%
            );
          }
        }
      }
      .list-content-item {
        display: flex;
        align-items: flex-start;
        line-height: 38px;
        gap: 10px;
        margin-bottom: 12px;
        border-bottom: 1px solid #e2e9ff;

        > svg {
          width: 18px;
          height: 18px;
        }
      }
      .empty-img {
        position: relative;
        bottom: -24px;
      }
    }
  }
}
</style>
